import { render, staticRenderFns } from "./PetugasLMSTambah.vue?vue&type=template&id=23786f5e&scoped=true&"
import script from "./PetugasLMSTambah.vue?vue&type=script&lang=js&"
export * from "./PetugasLMSTambah.vue?vue&type=script&lang=js&"
import style0 from "./PetugasLMSTambah.vue?vue&type=style&index=0&id=23786f5e&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23786f5e",
  null
  
)

export default component.exports